@if (!editorIsActive) {
  <button
    mat-raised-button
    color="basic"
    matTooltip="To avoid exceeding usage limit, please only open the content editor if you intend to edit the content. Note that each view of the rich text editor counts towards usage limit."
    [disabled]="isDisabled"
    (click)="openEditor()"
  >
    <mat-icon>edit</mat-icon>
    Open Editor
  </button>
}

@if (editorIsActive) {
  <editor
    [(ngModel)]="value"
    (ngModelChange)="updateChanges()"
    [disabled]="isDisabled"
    class="editor"
    apiKey="02rhwroz1sekok20wxley81k1fci7ijkmejhd73jdp5v4l7c"
    [init]="editorConfig"
    >{{ 'SHARED.COMPONENTS.EDITOR.MY_EDITOR' | translate }}</editor
  >
}
